/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { VivaLiteScanStrictHttpResponse } from '../../viva-lite-scan-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FileDownloadModel } from '../../models/file-download-model';

export interface AdminGetIvcHealthMonthlyUsageGet$Params {

/**
 * Any date in the calendar month to include (half-open range through month end)
 */
  month?: string;
}

export function adminGetIvcHealthMonthlyUsageGet(http: HttpClient, rootUrl: string, params?: AdminGetIvcHealthMonthlyUsageGet$Params, context?: HttpContext): Observable<VivaLiteScanStrictHttpResponse<FileDownloadModel>> {
  const rb = new RequestBuilder(rootUrl, adminGetIvcHealthMonthlyUsageGet.PATH, 'get');
  if (params) {
    rb.query('month', params.month, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as VivaLiteScanStrictHttpResponse<FileDownloadModel>;
    })
  );
}

adminGetIvcHealthMonthlyUsageGet.PATH = '/Admin/GetIVCHealthMonthlyUsage';
